import PropTypes from 'prop-types';

import {Container as BaseContainer, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component as ContentfulComponent} from '@amblique/contentful/app/components/contentful/component';

/**
 * Container component
 *
 * @param {Object} props - Component props
 * @param {Contentful.Container} props.component - Container component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const Container = ({component, isComplete = true, isFetching = false, ...props}) => {
  const styles = useMultiStyleConfig('contentful/container', {component, isComplete, isFetching});

  return (
    <BaseContainer {...styles.root} {...props}>
      {component.region1Collection?.items?.map((component) => (
        <ContentfulComponent key={`component[${component.sys.id}]`} component={component} />
      ))}
    </BaseContainer>
  );
};

Container.displayName = 'Container';
Container.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
